import { useEffect, useState } from "react";

import { SafeAreaView, View } from "react-native";
import { useTailwind } from "tailwind-rn";

import ConfirmPhone from "./components/ConfirmPhone";
import ResendVerification from "./components/ResendVerification";
import VerificationInput, {
  OTP_TOKEN_LENGTH,
} from "./components/VerificationInput";
import { KeyboardAwareView } from "../../../../components";
import useLogin from "../../contexts/LoginContext";
import LoginHeader from "../../navigation/LoginHeader";
import { VerificationMode } from "../../types";

export const verificationScreenOptions = {
  header: () => <LoginHeader title="Ingresa el código" disableBorder />,
};

export default function VerificationScreen() {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  const {
    country,
    cellphone,
    createLoginCode,
    onVerify,
    onError,
    onAskForHelp,
  } = useLogin();
  const countryCode = country.code;

  const resendCode = async (mode: VerificationMode) => {
    try {
      if (mode === "help") {
        onAskForHelp("Hola! Necesito ayuda con el código de verificación");
      } else {
        createLoginCode(countryCode, cellphone, mode);
      }
    } catch (e) {
      onError(e);
    }
  };

  const verifyCode = async () => {
    try {
      onVerify({ code, countryCode, cellphone });
    } catch {
      setError("El código ingresado no es el correcto");
    }
  };

  const resetError = () => {
    setError("");
    setCode("");
  };

  useEffect(() => {
    if (error) resetError();
    if (code.length === OTP_TOKEN_LENGTH) verifyCode();
  }, [code]);

  const tailwind = useTailwind();

  return (
    <SafeAreaView style={tailwind("flex-1")}>
      <KeyboardAwareView style={tailwind("justify-between m-4")}>
        <View>
          <VerificationInput code={code} error={error} setCode={setCode} />
          <ConfirmPhone countryCode={countryCode} phone={cellphone} />
        </View>
        <ResendVerification resendCode={resendCode} />
      </KeyboardAwareView>
    </SafeAreaView>
  );
}
